import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ReactiveFormsModule,
} from "@angular/forms";
import { Observable } from "rxjs";
import { ApiService } from "../services/api.service";
import { UserContextService } from "../services/user-context.service";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatInput } from "@angular/material/input";
import { MatOption } from "@angular/material/core";
import { AsyncPipe } from "@angular/common";
import { MatSelect } from "@angular/material/select";
import {
  MatFormField,
  MatLabel,
  MatSuffix,
} from "@angular/material/form-field";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { MatDialogTitle } from "@angular/material/dialog";
import { MatDivider, MatDividerModule } from "@angular/material/divider";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-param",
  templateUrl: "./param.component.html",
  styleUrls: ["./param.component.css"],
  standalone: true,
  imports: [
    MatDialogTitle,
    ReactiveFormsModule,
    MatTabGroup,
    MatTab,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatInput,
    MatCheckbox,
    MatIcon,
    MatSuffix,
    MatTooltip,
    AsyncPipe,
    MatDivider,
    MatDividerModule,
    MatButtonModule,
  ],
})
export class ParamComponent implements OnInit {
  instance: any;
  instanceForm: UntypedFormGroup = this.fb.group({
    UniteProd: new UntypedFormControl({ value: null, disabled: false }),
    Centre: new UntypedFormControl({ value: null, disabled: false }),
    FamPoste: new UntypedFormControl({ value: null, disabled: false }),
    Poste: new UntypedFormControl({ value: null, disabled: false }),
    Ressource: new UntypedFormControl({ value: null, disabled: false }),
    NumClient: new UntypedFormControl({ value: null, disabled: false }),
    NumAffaire: new UntypedFormControl({ value: null, disabled: false }),
    HorJour: new UntypedFormControl({ value: null, disabled: false }),
    HorSemaine: new UntypedFormControl({ value: null, disabled: false }),
    HorMois: new UntypedFormControl({ value: null, disabled: false }),
    OfFerme: new UntypedFormControl({ value: null, disabled: false }),
    OfLance: new UntypedFormControl({ value: null, disabled: false }),
    OfPrevu: new UntypedFormControl({ value: null, disabled: false }),
    OfEncours: new UntypedFormControl({ value: null, disabled: false }),
    Regle: new UntypedFormControl({ value: null, disabled: false }),
    NumOf: new UntypedFormControl({ value: null, disabled: false }),
    RegleTriof: new UntypedFormControl({ value: null, disabled: false }),
    NonVisuop: new UntypedFormControl({ value: null, disabled: false }),
    BatchDefaut: new UntypedFormControl({ value: null, disabled: false }),
    ExpressRealise: new UntypedFormControl({ value: null, disabled: false }),
    FormatDate: new UntypedFormControl({ value: null, disabled: false }),
    ArticleDefaut: new UntypedFormControl({ value: null, disabled: false }),
    ProcedureOracle: new UntypedFormControl({ value: null, disabled: false }),
    Param1ProcOracle: new UntypedFormControl({ value: null, disabled: false }),
    Param2ProcOracle: new UntypedFormControl({ value: null, disabled: false }),
    Param3ProcOracle: new UntypedFormControl({ value: null, disabled: false }),
    Param4ProcOracle: new UntypedFormControl({ value: null, disabled: false }),
    Param5ProcOracle: new UntypedFormControl({ value: null, disabled: false }),
    RetourProcOracle: new UntypedFormControl({ value: null, disabled: false }),
    AffectResop: new UntypedFormControl({ value: null, disabled: false }),
    GestDispoComposof: new UntypedFormControl({ value: null, disabled: false }),
    ShowRessources: new UntypedFormControl({ value: null, disabled: false }),
    HideOfTask: new UntypedFormControl({ value: null, disabled: false }),
    SeqCalcCharges: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser1: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser2: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser3: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser4: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser5: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser6: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser7: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser8: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser9: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser10: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser11: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser12: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser13: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser14: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser15: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser16: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser17: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser18: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser19: new UntypedFormControl({ value: null, disabled: false }),
    TitreUser20: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser1: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser2: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser3: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser4: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser5: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser6: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser7: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser8: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser9: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser10: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser11: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser12: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser13: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser14: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser15: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser16: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser17: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser18: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser19: new UntypedFormControl({ value: null, disabled: false }),
    RegleUser20: new UntypedFormControl({ value: null, disabled: false }),
    NbChampsUserOpOnMainTab: new UntypedFormControl({
      value: null,
      disabled: false,
    }),
    TodayMarkerColor: new UntypedFormControl({ value: null, disabled: false }),
    CurrentWeekColor: new UntypedFormControl({ value: null, disabled: false }),
    OfLeftsideText: new UntypedFormControl({ value: null, disabled: false }),
    OfRightsideText: new UntypedFormControl({ value: null, disabled: false }),
    OpLeftsideText: new UntypedFormControl({ value: null, disabled: false }),
    OpRightsideText: new UntypedFormControl({ value: null, disabled: false }),

    TextOfFormula: new UntypedFormControl({ value: null, disabled: false }),
    TextOpFormula: new UntypedFormControl({ value: null, disabled: false }),
    RowHeight: new UntypedFormControl({ value: null, disabled: false }),
    RowHeightOp: new UntypedFormControl({ value: null, disabled: false }),
    RowHeightEnt: new UntypedFormControl({ value: null, disabled: false }),
    RowHeightCent: new UntypedFormControl({ value: null, disabled: false }),
    RowHeightPoste: new UntypedFormControl({ value: null, disabled: false }),
    OfBackground: new UntypedFormControl({ value: null, disabled: false }),
    OfTextcolor: new UntypedFormControl({ value: null, disabled: false }),
    OpBackground: new UntypedFormControl({ value: null, disabled: false }),
    OpTextcolor: new UntypedFormControl({ value: null, disabled: false }),

    CentreBackground: new UntypedFormControl({ value: null, disabled: false }),
    PosteBackground: new UntypedFormControl({ value: null, disabled: false }),
    EntBackground: new UntypedFormControl({ value: null, disabled: false }),
    CentreTextcolor: new UntypedFormControl({ value: null, disabled: false }),
    PosteTextcolor: new UntypedFormControl({ value: null, disabled: false }),
    EntTextcolor: new UntypedFormControl({ value: null, disabled: false }),
    OfPBackground: new UntypedFormControl({ value: null, disabled: false }),
    OfFBackground: new UntypedFormControl({ value: null, disabled: false }),
    OfEBackground: new UntypedFormControl({ value: null, disabled: false }),
    OfLBackground: new UntypedFormControl({ value: null, disabled: false }),
    OfPTextcolor: new UntypedFormControl({ value: null, disabled: false }),
    OfFTextcolor: new UntypedFormControl({ value: null, disabled: false }),
    OfETextcolor: new UntypedFormControl({ value: null, disabled: false }),
    OfLTextcolor: new UntypedFormControl({ value: null, disabled: false }),
    TooltipContentOf: new UntypedFormControl({ value: null, disabled: false }),
    TooltipOf: new UntypedFormControl({ value: null, disabled: false }),
  });
  entrepots$: Observable<any> = new Observable();
  centres$: Observable<any> = new Observable();
  postes$: Observable<any> = new Observable();
  ressources$: Observable<any> = new Observable();
  batchs$: Observable<any> = new Observable();
  regles$: Observable<any> = new Observable();
  indicesUserfields = [...Array(20).keys()].map((i) => i + 1);
  triOf: any[] = [
    {
      value: "Par Poste - Date de Début Jalon OP",
      viewValue: "Par Poste - Date de Début Jalon OP",
    },
    {
      value: "Par Poste - Priorité / Numéro OF",
      viewValue: "Par Poste - Priorité / Numéro OF",
    },
    {
      value: "Par Poste - Numéro d'ordre",
      viewValue: "Par Poste - Numéro d'ordre",
    },
  ];
  realise: any[] = [
    { value: "Temps", viewValue: "Temps" },
    { value: "Quantité", viewValue: "Quantité" },
  ];
  constructor(
    private fb: UntypedFormBuilder,
    private apiService: ApiService,
    private userContext: UserContextService,
  ) {}

  ngOnInit() {
    this.apiService
      .generateHttpRequest(null, "CalcCharges", null, "GET", null)
      .pipe()
      .subscribe((result) => {
        this.instance = result;
        // string to number
        this.instance.BatchDefaut = +this.instance.BatchDefaut;
        this.instanceForm.patchValue(this.instance);
      });
    const query = this.apiService.getQueryParamForSite(
      this.userContext.siteConnexion,
    );
    this.entrepots$ = this.apiService.getSelect(query, "entrepot").pipe();
    this.centres$ = this.apiService.getSelect(query, "centre").pipe();
    this.postes$ = this.apiService.getSelect(query, "poste").pipe();
    this.ressources$ = this.apiService.getSelect(query, "ressource").pipe();
    this.batchs$ = this.apiService.getSelect(query, "batch").pipe();
    this.regles$ = this.apiService.getSelect(query, "regle").pipe();
  }
  save() {
    this.apiService
      .generateHttpRequest(
        null,
        "CalcCharges",
        this.instanceForm.value,
        "PUT",
        null,
      )
      .subscribe();
  }
  refresh() {
    this.ngOnInit();
  }

  formatJson(): void {
    try {
      const parsed = JSON.parse(
        this.instanceForm.get("TooltipContentOf")?.value || "",
      );
      this.instanceForm.patchValue({
        TooltipContentOf: JSON.stringify(parsed, null, 2),
      });
      //this.errorMessage = null;
    } catch (e) {
      //this.errorMessage = 'JSON invalide';
    }
  }
}
